<!--
 * @Description: 海报模板02
 * @Author: xiawenlong
 * @Date: 2021-10-14 10:08:27
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-02-16 14:10:19
-->
<template>
  <div ref="app" :class="['template02', { border: isBorder }]">
    <div class="text">
      <el-input v-model="contentData.title1" class="title title1"></el-input>
      <el-input v-model="contentData.title2" class="title title2"></el-input>
      <el-input v-model="contentData.teacher" class="teacher"></el-input>
      <el-input v-model="contentData.date" class="date"></el-input>
      <el-input
        v-model="contentData.content"
        type="textarea"
        class="content"
        :rows="4"
        resize="none"
      ></el-input>
      <div class="qrcode">
        <div class="code">
          <img :src="qrCode" alt="" />
        </div>
        <div class="des">
          <p>保存图片或使用微信</p>
          <p>>>扫一扫识别二维码</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'Template02',
  props: {
    qrCode: {
      type: String,
      default: '',
    },
    templateBackground: {
      type: String,
      default: '',
    },
    isBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contentData: {
        title1: '企业如何做好',
        title2: '生产与管理？',
        teacher: '某老师',
        content:
          '1.培训内容培训内容培训内容培训内容内容 2.培训内容培训内容培训内容培训内容内容 3.培训内容培训内容培训内容培训内容内容 4.培训内容培训内容培训内容培训内容内容',
        date: '2021.06.03 — 2021.06.06',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      const $app = this.$refs.app
      const standardScale = 2208 / 1242
      window.addEventListener(
        'resize',
        _.debounce(() => {
          const docHeight = document.querySelector('.design-wrapper').clientHeight
          const docWidth = document.querySelector('.design-wrapper').clientWidth

          const currentScale = docHeight / docWidth
          let [scale, translate] = [0, 0]
          if (currentScale < standardScale) {
            // 以高度计算
            scale = docHeight / 2208
            const shouleWidth = 1242 * scale
            const offsetWidth = docWidth - shouleWidth
            translate = offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : ''
          } else {
            // 以宽度计算
            scale = docWidth / 1242
            const shouleHeight = 2208 * scale
            const offsetHeight = docHeight - shouleHeight
            translate = offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : ''
          }
          console.log(translate)
          // background:url(${this.templateBackground});
          $app.style.cssText = `
            transform: scale(${scale});
            min-width: 1242px;
            min-height: 2208px;
          `
        }),
        200,
      )

      if (document.createEvent) {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      } else if (document.createEventObject) {
        window.fireEvent('onresize')
      }
    })
  },
}
</script>
<style lang="scss" scoped>
@font-face {
  font-family: Source Han Sans CN-Bold;
  src: url('../../../../../font/SourceHanSansCN-Bold.otf');
}
@font-face {
  font-family: Source Han Sans CN-Medium;
  src: url('../../../../../font/SourceHanSansCN-Medium.otf');
}
@font-face {
  font-family: Source Han Sans CN-Regular;
  src: url('../../../../../font/SourceHanSansCN-Regular.otf');
}
.template02 {
  overflow: hidden;
  background: rgba(0, 0, 0, 0);
  position: relative;
  min-width: 1242px;
  min-height: 2208px;
  background: url('../../../../../assets/posterTemplate/template02.png') no-repeat;
  background-size: 100% 100%;
  .text {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    ::v-deep.el-input {
      input {
        vertical-align: top;
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        overflow: hidden;
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.title {
      position: absolute;
      top: 334px;
      left: 180px;
      display: block;
      width: 844px;
      height: 155px;
      margin: 0 auto;
      input {
        font-size: 135px;
        font-family: Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: left;
        color: #282828;
        line-height: 179px;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep.title2 {
      top: 514px;
      left: 180px;
      input {
        color: #45ad93;
      }
    }
    ::v-deep.teacher {
      position: absolute;
      top: 746px;
      left: 420px;
      display: block;
      width: 363px;
      input {
        font-size: 55px;
        font-family: Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: center;
        color: #282828;
        line-height: 67px;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep .content {
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      top: 1140px;
      left: 218px;
      width: 800px;
      height: 248px;
      textarea {
        padding: 0 10px;
        font-size: 40px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: left;
        color: #282828;
        line-height: 70px;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep.date {
      position: absolute;
      top: 928px;
      left: 440px;
      display: block;
      width: 582px;
      input {
        font-size: 40px;
        font-family: Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #282828;
        line-height: 53px;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    .qrcode {
      position: absolute;
      top: 1892px;
      left: 167px;
      display: flex;
      align-items: center;
      .code {
        width: 297px;
        height: 297px;
        margin-right: 92px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .des {
        font-size: 61px;
        font-family: Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        line-height: 91px;
      }
    }
  }
  &.border {
    ::v-deep.el-input {
      input {
        border: 2px dashed #c9c9c9;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        border: 2px dashed #c9c9c9;
      }
    }
  }
  img {
    height: 100%;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
    pointer-events: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
</style>
